/* LockedFans store — theme.js. Progressive enhancement only: every page works with this file missing. */
(function () {
  'use strict';

  // ---- header: the mobile drawer sits under the header, so measure where the header ends
  var header = document.querySelector('.site-header');
  function setHeaderBottom() {
    if (!header) return;
    var r = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(0, r.bottom) + 'px');
  }
  setHeaderBottom();
  window.addEventListener('resize', setHeaderBottom, { passive: true });
  window.addEventListener('scroll', setHeaderBottom, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.mobile-menu[open], .facets__toggle[open]');
    if (!open) return;
    open.removeAttribute('open');
    var s = open.querySelector('summary');
    if (s) s.focus();
  });

  // ---- product: option radios → the matching variant (id, price, URL, button state)
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var form = section.querySelector('[data-product-form]');
    var dataEl = section.parentNode.querySelector('script[data-variants]') || document.querySelector('script[data-variants]');
    if (!form || !dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('[data-variant-id]');
    var select = form.querySelector('[data-variant-select]');
    var radios = form.querySelector('[data-variant-radios]');
    var addBtn = form.querySelector('[data-add]');
    var priceEl = section.querySelector('[data-price]');
    if (!radios || !idInput) return;
    // JS owns the variant now: the hidden input submits, the fallback select does not.
    idInput.disabled = false;
    if (select) select.removeAttribute('name');
    var labels = { add: addBtn ? addBtn.textContent.trim() : '', soldOut: 'Sold out', unavailable: 'Unavailable' };

    function selected() {
      var out = [];
      radios.querySelectorAll('fieldset').forEach(function (fs, i) {
        var c = fs.querySelector('input:checked');
        out[i] = c ? c.value : null;
        var shown = section.querySelector('[data-option-value="' + i + '"]');
        if (shown && c) shown.textContent = c.value;
      });
      return out;
    }
    function update() {
      var opts = selected();
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = labels.unavailable; }
        return;
      }
      idInput.value = v.id;
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? labels.add : labels.soldOut; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    radios.addEventListener('change', update);
  });

  // ---- cart: quantity steppers submit the cart form (after any gift mirror in flight has landed: see below).
  // form.submit() on purpose: it skips the gift check, which guards CHECKOUT, not a quantity change.
  var cartFlush = function (done) { done(); };
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
        input.value = next;
        var form = input.form;
        if (form) cartFlush(function () { form.submit(); });
      });
    });
  });

  // ---- cart: the gift form (sections/main-cart.liquid). Every rule here closes a way the WRONG person gets the
  // months, because the app routes a gift's months to the email typed here and never to the buyer:
  //  1. Unticked: the recipient inputs are disabled, so the blank hidden inputs before them are what gets posted.
  //  2. Ticked: checkout is blocked until there is a name and a valid email typed the same way twice.
  //  3. Express buttons read the CART, not this form. So every change is mirrored to the cart (/cart/update.js,
  //     debounced), and the buttons stay hidden while it is a gift, or while the cart may still hold an old "Yes".
  //  4. A submit waits for a mirror request in flight, so an older snapshot can't land after the form's own values.
  var giftBox = document.querySelector('[data-gift]');
  var giftForm = giftBox && giftBox.closest('form');
  var giftToggle = giftBox && giftBox.querySelector('[data-gift-toggle]');
  var giftName = giftBox && giftBox.querySelector('[data-gift-name]');
  var giftEmail = giftBox && giftBox.querySelector('[data-gift-email]');
  var giftConfirm = giftBox && giftBox.querySelector('[data-gift-confirm]');
  var giftNote = giftBox && giftBox.querySelector('[data-gift-note]');
  if (giftForm && giftToggle && giftName && giftEmail && giftConfirm) {
    var giftStatus = giftForm.querySelector('[data-gift-status]');
    var giftFields = [giftName, giftEmail, giftConfirm, giftNote].filter(Boolean);
    var giftChecks = [['name', giftName], ['email', giftEmail], ['match', giftConfirm]];
    var updateUrl = giftBox.getAttribute('data-update-url') || '/cart/update.js';
    var cartGift = giftBox.getAttribute('data-gift-saved') === 'Yes' ? 'Yes' : 'No'; // what the cart holds, as far as we know
    var CONFIRMED_KEY = 'lfGiftEmailConfirmed';
    // The browser's own type=email rule, plus a dot in the domain (an address with no TLD can't receive mail).
    var EMAIL_RE = /^[A-Za-z0-9.!#$%&'*+\/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
    var attempted = false;
    var touched = {};
    var timer = null;
    var inflight = null;
    var queued = false;

    var clean = function (v) { return String(v || '').replace(/^\s+|\s+$/g, ''); };
    var store = function (fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } };

    // This script does the checking, with inline messages. Native bubbles would fire first and differently, and the
    // no-JS fallback keeps type=email in the markup. inputmode keeps the email keyboard on phones.
    [giftEmail, giftConfirm].forEach(function (el) { el.type = 'text'; el.setAttribute('inputmode', 'email'); });

    var problems = function () {
      if (!giftToggle.checked) return [];
      var out = [];
      var email = clean(giftEmail.value);
      if (!clean(giftName.value)) out.push('name');
      if (!email || email.length > 254 || !EMAIL_RE.test(email)) out.push('email');
      else if (email.toLowerCase() !== clean(giftConfirm.value).toLowerCase()) out.push('match');
      return out;
    };
    var paint = function () {
      var list = problems();
      giftChecks.forEach(function (c) {
        var err = giftBox.querySelector('[data-gift-error="' + c[0] + '"]');
        var show = list.indexOf(c[0]) !== -1 && (attempted || touched[c[0]]);
        if (show) c[1].setAttribute('aria-invalid', 'true'); else c[1].removeAttribute('aria-invalid');
        if (err) {
          err.hidden = !show;
          if (show) c[1].setAttribute('aria-describedby', err.id); else c[1].removeAttribute('aria-describedby');
        }
      });
      if (!list.length && giftStatus) giftStatus.textContent = '';
      if (!list.length && giftToggle.checked) {
        var confirmed = clean(giftEmail.value).toLowerCase();
        store(function (s) { s.setItem(CONFIRMED_KEY, confirmed); });
      }
      return list;
    };
    var syncExpress = function () {
      giftForm.classList.toggle('is-gift', giftToggle.checked || cartGift === 'Yes');
    };

    // The cart mirror. Unticked sends "No" and blanks, so express checkout can never carry a leftover recipient.
    var snapshot = function () {
      var on = giftToggle.checked;
      return {
        'Gift': on ? 'Yes' : 'No',
        'Gift recipient name': on ? clean(giftName.value) : '',
        'Gift recipient email': on ? clean(giftEmail.value) : '',
        'Gift note': on && giftNote ? clean(giftNote.value) : ''
      };
    };
    var send = function () {
      timer = null;
      if (inflight) { queued = true; return; }
      var attrs = snapshot();
      inflight = fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      })
        .then(function (r) { if (r.ok) cartGift = attrs.Gift; })
        .catch(function () { /* the form post still carries the right values; express stays hidden meanwhile */ })
        .then(function () {
          inflight = null;
          syncExpress();
          if (queued) { queued = false; send(); }
        });
    };
    var schedule = function (ms) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(send, ms);
    };
    // Before the form posts: drop the pending mirror (the post carries the same values) and wait for one in flight,
    // at most a few seconds, so a slow request can't hold the checkout button hostage.
    cartFlush = function (done) {
      if (timer) { clearTimeout(timer); timer = null; }
      queued = false;
      if (!inflight) { done(); return; }
      var called = false;
      var once = function () { if (!called) { called = true; done(); } };
      inflight.then(once, once);
      setTimeout(once, 4000);
    };

    var syncGift = function () {
      var on = giftToggle.checked;
      giftBox.classList.toggle('is-open', on);
      giftFields.forEach(function (el) { el.disabled = !on; });
      if (!on) {
        attempted = false;
        touched = {};
        if (giftStatus) giftStatus.textContent = '';
      }
      paint();
      syncExpress();
    };

    giftToggle.addEventListener('change', function () { syncGift(); schedule(0); });
    giftFields.forEach(function (el) {
      el.addEventListener('input', function () {
        paint();
        if (el !== giftConfirm) schedule(600);
      });
    });
    giftChecks.forEach(function (c) {
      c[1].addEventListener('blur', function () {
        var v = clean(c[1].value);
        if (v !== c[1].value) c[1].value = v; // a stray space from autofill or paste: what you see is what is sent
        if (v) { touched[c[0]] = true; paint(); }
      });
    });

    giftForm.addEventListener('submit', function (e) {
      // Only an explicit non-checkout button skips the check. Enter in a field submits through Checkout, and a
      // browser that can't name the submitter gets the check too: it fails toward asking.
      var checkout = !(e.submitter && e.submitter.name !== 'checkout');
      if (checkout) {
        attempted = true;
        var list = paint();
        if (list.length) {
          e.preventDefault();
          if (giftStatus) {
            giftStatus.textContent = '';
            giftStatus.textContent = giftStatus.getAttribute('data-message') || '';
          }
          var first = giftChecks.filter(function (c) { return c[0] === list[0]; })[0];
          if (first) first[1].focus();
          return;
        }
      }
      if (timer || inflight) {
        e.preventDefault();
        var submitter = e.submitter;
        cartFlush(function () {
          if (submitter && giftForm.requestSubmit) { giftForm.requestSubmit(submitter); return; }
          if (checkout) {
            var go = document.createElement('input');
            go.type = 'hidden';
            go.name = 'checkout';
            giftForm.appendChild(go);
          }
          giftForm.submit();
        });
      }
    });

    // The confirmation is never posted, so a reload (a quantity change) would empty it. Refill it only with an
    // address this tab already saw typed the same way twice.
    var confirmedBefore = store(function (s) { return s.getItem(CONFIRMED_KEY); });
    if (confirmedBefore && clean(giftEmail.value).toLowerCase() === confirmedBefore) giftConfirm.value = giftEmail.value;

    syncGift();
    // A recipient left in the cart from a no-JS post while unticked: clear it, so express checkout can't carry it.
    if (!giftToggle.checked && giftBox.hasAttribute('data-gift-leftover')) schedule(0);
  }

  // ---- product videos: start muted (autoplay needs it); the speaker button toggles sound
  document.querySelectorAll('[data-video-sound]').forEach(function (btn) {
    var video = btn.parentElement && btn.parentElement.querySelector('video');
    if (!video) { btn.hidden = true; return; }
    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      if (!video.muted) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      btn.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
    });
  });

  // ---- collection: sort applies on change
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { if (el.form) el.form.submit(); });
  });

  // ---- hero video (sections/hero): the photograph is the first paint; the video starts only once the page has loaded,
  // only when motion and data are welcome, and fades in when it is really playing. Phones get the phone cut when there is
  // one, and a screen that crosses the phone width (a rotated tablet, a resized window) switches cut, back to the photo
  // until the new one plays. Off-screen it pauses; the pause button stops it until pressed again (WCAG 2.2.2).
  var heroVideos = document.querySelectorAll('[data-hero-video]');
  if (heroVideos.length) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection;
    var saveData = conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''));
    if (!reduceMotion && !saveData) {
      var phoneMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
      var startHeroVideos = function () {
        heroVideos.forEach(function (video) {
          var hero = video.closest('.hero');
          var toggle = hero && hero.querySelector('[data-hero-video-toggle]');
          var wide = video.getAttribute('data-src') || '', phoneCut = video.getAttribute('data-src-phone') || '';
          var phoneFallback = video.getAttribute('data-src-phone-fallback') || '';
          var userPaused = false, onScreen = !('IntersectionObserver' in window);
          var showState = function (playing) {
            if (!toggle) return;
            toggle.classList.toggle('is-paused', !playing);
            toggle.setAttribute('aria-label', playing ? 'Pause the video' : 'Play the video');
          };
          var play = function () { if (!video.getAttribute('src')) return; var p = video.play(); if (p && p.catch) p.catch(function () {}); };
          // the file for this screen: the phone cut (or the main video) on phones, the main video elsewhere — none means the photo
          var load = function () {
            var src = phoneMq && phoneMq.matches ? (phoneCut || wide) : wide;
            if (src === (video.getAttribute('src') || '')) return;
            if (hero) hero.classList.remove('is-playing');
            video.pause();
            if (!src) { video.removeAttribute('src'); video.load(); return; }
            video.src = src;
            if (onScreen && !userPaused) play();
          };
          video.muted = true;   // autoplay is only allowed muted; set the property, not just the attribute
          video.preload = 'auto';
          video.addEventListener('playing', function () { if (hero) hero.classList.add('is-playing'); showState(true); });
          video.addEventListener('pause', function () { showState(false); });
          // the phone file is DERIVED from the listed one's name (sections/hero): if it ever fails, the listed one
          video.addEventListener('error', function () {
            if (phoneFallback && video.getAttribute('src') === phoneCut) { phoneCut = phoneFallback; phoneFallback = ''; load(); }
          });
          if (toggle) toggle.addEventListener('click', function () {
            if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); }
          });
          load();
          if (phoneMq) { if (phoneMq.addEventListener) phoneMq.addEventListener('change', load); else if (phoneMq.addListener) phoneMq.addListener(load); }
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
              entries.forEach(function (e) {
                onScreen = e.isIntersecting;
                if (onScreen) { if (!userPaused) play(); } else if (!video.paused) video.pause();
              });
            }, { threshold: 0.15 }).observe(video);
          } else {
            play();
          }
        });
      };
      if (document.readyState === 'complete') startHeroVideos();
      else window.addEventListener('load', startHeroVideos, { once: true });
    }
  }
})();
